// vim: sts=2:ts=2:sw=2
/* jshint undef: true, unused: true */
/* global confirm_modal */

import jQuery from 'jquery';

const $ = jQuery;

(function(){

  function post(path, params, method) {
    method = method || 'post'; // Set method to post by default if not specified.

    // The rest of this code assumes you are not using a library.
    // It can be made less wordy if you use one.
    var form = document.createElement('form');
    form.setAttribute('method', method);
    form.setAttribute('action', path);

    for(var key in params) {
      if(params.hasOwnProperty(key)) {
        var hiddenField = document.createElement('input');
        hiddenField.setAttribute('type', 'hidden');
        hiddenField.setAttribute('name', key);
        hiddenField.setAttribute('value', params[key]);

        form.appendChild(hiddenField);
      }
    }

    document.body.appendChild(form);
    form.submit();
  }

  $('button.close-tab').on('click enter', function(e){
    e.preventDefault();// prevent default link behaviour
    var user_id = $(this).data('userid');
    var site = $(this).data('site');
    var url = $(this).data('url');
    var csrf = $(this).data('csrf');

    var callback = function(ok){
      if (ok){
        post(url, {user_id: user_id, site: site, submit_delete_site: '', csrf_token: csrf});
      }
    };
    confirm_modal('Delete site &quot;' + site + '&quot;', 'Do you really want to delete the site &quot;' + site + '&quot; with all its rules?', 'cancel', 'delete', callback); 
  });

  $('#check_show_blacklist').change(function() {
    $(this).closest('form').submit();
  });
  $('#check_show_se').change(function() {
    $(this).closest('form').submit();
  });

  $('#is_spam').change(function() {
    if ($(this.checked)){
      $('#is_se').prop('checked', false);
    }
  });
  $('#is_se').change(function() {
    if ($(this.checked)){
      $('#is_spam').prop('checked', false);
    }
  });

  // dropdown login menu should not close if input fields are clicked 
  $('.dropdown input, .dropdown label').click(function(e) {
    e.stopPropagation();
  });

}());

